var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c(_vm.htmlTag ? _vm.htmlTag : 'div',{ref:"sticky",tag:"component",class:[
            'b-sticky',
            _vm.position ? _vm.position : 'absolute',
            _vm.y ? _vm.y : 'top-0',
            _vm.x ? _vm.x : 'left-0' ],attrs:{"data-scroll":"","data-scroll-sticky":"","data-scroll-target":_vm.target && _vm.target !== '' ? _vm.target : '#stickyTarget'}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }